import { BlameLogRefType, BlameLogType, caseLifecycleTypes, debtorUpdateTypes, documentTypes, economyTypes, interactionTypes, paymentPlanTypes, settingTypes, tribunalTypes, workflowTypes, } from '@debbie/common/dist/blamelog/index.js';
import { Site } from '@debbie/common/dist/index.js';
import { useBlameLogs } from '@debbie/cortex/dist/blamelogs/index.js';
import { h } from '@debbie/cortex/dist/index.js';
import moment from 'moment';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Modal } from '..//index.js';
import PerformedBy from '../performed-by/PerformedBy.js';
import { Tab, TabList, TabPanel, Tabs } from '../Tabs.js';
import { BlameLogList } from './BlameLogList.js';
const BlameLogCmp = (props) => {
    const lang = useSelector((s) => s.lang);
    const site = useSelector((s) => s.site);
    const blameLogsLoader = useBlameLogs(props.refType, props.refId, {}, 0, 1);
    const [open, setOpen] = useState(false);
    return (React.createElement(React.Fragment, null,
        site === Site.Caseworker &&
            h.hasData(blameLogsLoader) &&
            blameLogsLoader.data.items.length > 0 ? (React.createElement("div", { style: { cursor: 'pointer' }, onClick: () => {
                setOpen(!open);
            } },
            React.createElement(PerformedBy, { performedBy: blameLogsLoader.data.items[0].performedBy }),
            ' ',
            React.createElement("span", { style: {
                    fontSize: '.6em',
                } },
                lang.blameLogs.logged,
                ' ',
                moment
                    .duration(moment(blameLogsLoader.data.items[0].loggedAt).diff(moment()))
                    .humanize(),
                ' ',
                lang.blameLogs.ago))) : (props.refType !== BlameLogRefType.Case && (React.createElement("div", null, lang.blameLogs.noLogs))),
        open && (React.createElement(Modal, { onToggle: () => setOpen(!open), header: lang.blameLogs.blameLog, maxWidth: "960px" },
            React.createElement(BlameLogsContent, { refId: props.refId, refType: props.refType })))));
};
export default BlameLogCmp;
export const BlameLogsContent = (props) => {
    const lang = useSelector((s) => s.lang);
    return (React.createElement("div", null,
        React.createElement(Tabs, { defaultIndex: 0 },
            React.createElement(TabList, null,
                props.refType === BlameLogRefType.Case && (React.createElement(React.Fragment, null,
                    React.createElement(Tab, null, lang.blameLogs.overview),
                    React.createElement(Tab, null, lang.blameLogs.userVisits),
                    React.createElement(Tab, null, lang.blameLogs.caseLifecycle),
                    React.createElement(Tab, null, lang.blameLogs.economy),
                    React.createElement(Tab, null, lang.blameLogs.paymentPlans),
                    React.createElement(Tab, null, lang.blameLogs.interactions),
                    React.createElement(Tab, null, lang.blameLogs.workflow),
                    React.createElement(Tab, null, lang.documents.documents),
                    React.createElement(Tab, null, lang.blameLogs.tribunal))),
                props.refType === BlameLogRefType.UserOnCustomer && (React.createElement(React.Fragment, null,
                    React.createElement(Tab, null, lang.blameLogs.overview),
                    React.createElement(Tab, null, lang.blameLogs.userVisits),
                    React.createElement(Tab, null, lang.blameLogs.debtorUpdates))),
                props.refType === BlameLogRefType.Creditor && (React.createElement(React.Fragment, null,
                    React.createElement(Tab, null, lang.blameLogs.overview),
                    React.createElement(Tab, null, lang.blameLogs.userVisits),
                    React.createElement(Tab, null, lang.blameLogs.settings))),
                props.refType === BlameLogRefType.TenantSettings && (React.createElement(React.Fragment, null,
                    React.createElement(Tab, null, lang.blameLogs.overview),
                    React.createElement(Tab, null, lang.blameLogs.settings)))),
            props.refType === BlameLogRefType.Case && (React.createElement(React.Fragment, null,
                React.createElement(TabPanel, null,
                    React.createElement(BlameLogList, { refType: props.refType, refId: props.refId, types: [] })),
                React.createElement(TabPanel, null,
                    React.createElement(BlameLogList, { refType: props.refType, refId: props.refId, types: [BlameLogType.CaseVisit] })),
                React.createElement(TabPanel, null,
                    React.createElement(BlameLogList, { refType: props.refType, refId: props.refId, types: caseLifecycleTypes })),
                React.createElement(TabPanel, null,
                    React.createElement(BlameLogList, { refType: props.refType, refId: props.refId, types: economyTypes })),
                React.createElement(TabPanel, null,
                    React.createElement(BlameLogList, { refType: props.refType, refId: props.refId, types: paymentPlanTypes })),
                React.createElement(TabPanel, null,
                    React.createElement(BlameLogList, { refType: props.refType, refId: props.refId, types: interactionTypes })),
                React.createElement(TabPanel, null,
                    React.createElement(BlameLogList, { refType: props.refType, refId: props.refId, types: workflowTypes })),
                React.createElement(TabPanel, null,
                    React.createElement(BlameLogList, { refType: props.refType, refId: props.refId, types: documentTypes })),
                React.createElement(TabPanel, null,
                    React.createElement(BlameLogList, { refType: props.refType, refId: props.refId, types: tribunalTypes })))),
            props.refType === BlameLogRefType.UserOnCustomer && (React.createElement(React.Fragment, null,
                React.createElement(TabPanel, null,
                    React.createElement(BlameLogList, { refType: props.refType, refId: props.refId, types: [] })),
                React.createElement(TabPanel, null,
                    React.createElement(BlameLogList, { refType: props.refType, refId: props.refId, types: [BlameLogType.UserOnCustomerVisit] })),
                React.createElement(TabPanel, null,
                    React.createElement(BlameLogList, { refType: props.refType, refId: props.refId, types: debtorUpdateTypes })))),
            props.refType === BlameLogRefType.Creditor && (React.createElement(React.Fragment, null,
                React.createElement(TabPanel, null,
                    React.createElement(BlameLogList, { refType: props.refType, refId: props.refId, types: [] })),
                React.createElement(TabPanel, null,
                    React.createElement(BlameLogList, { refType: props.refType, refId: props.refId, types: [BlameLogType.CreditorVisit] })),
                React.createElement(TabPanel, null,
                    React.createElement(BlameLogList, { refType: props.refType, refId: props.refId, types: settingTypes })))),
            props.refType === BlameLogRefType.TenantSettings && (React.createElement(React.Fragment, null,
                React.createElement(TabPanel, null,
                    React.createElement(BlameLogList, { refType: props.refType, refId: props.refId, types: [] })),
                React.createElement(TabPanel, null,
                    React.createElement(BlameLogList, { refType: props.refType, refId: props.refId, types: settingTypes })))))));
};
//# sourceMappingURL=BlameLog.js.map